import React, { Component } from "react";
import AdminPOIListItem from './AdminPOIListItem.js';

class AdminPOIList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    componentDidMount() {
        this.setState({
            POIs: this.props.POIs
        });
    }
    componentDidUpdate(oldProps) {
        if (oldProps.POIs !== this.props.POIs) {
            this.setState({
                POIs: this.props.POIs
            });
        }
    }
    render() {
        if (!this.state.POIs) return (<AdminPOIListItem getPOIData={this.props.getPOIData} key='createNewPOI' />)

        const POIs = structuredClone(this.state.POIs);
        let POIList = [];
        for (let POI of POIs) {
            if ((this.props.selectedPOI && POI._id == this.props.selectedPOI) || (!this.props.selectedPOI)) {
                POIList.push(
                    <AdminPOIListItem POI={POI} key={POI._id} getPOIData={this.props.getPOIData} />
                )
            }
        }

        return (
            <ul className="AdminUserList">
                <AdminPOIListItem getPOIData={this.props.getPOIData} key='createNewPOI' />
                {POIList}
            </ul>
        );
    }

}



export default AdminPOIList;
